<template>
  <div class="login_container">
    <div class="img-form">
      <div class="avatar_box">
        <div
          class="baImg bg-image"
          v-if="baImg && baImg.length > 0"
          :style="{ backgroundImage: 'url(' + baImg + ')' }"
        ></div>
        <el-dropdown class="message-wrap" placement="bottom" :show-timeout="0">
          <div class="lang-trigger">
            <icon-font
              class="lang-icon"
              name="language1"
              :size="18"
            />
            <span>{{ $t('_lang') }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(val, key) in i18nMessages" :key="key" @click.native="changeLang(key)">{{ val._lang }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="footer-container">
          <!--        <div class="footer">千仓科技供应链，专注中日国际物流</div>-->
          <!--        <div class="about">Copyright © www.zxwl.com, All Rights Reserved.</div>-->
        </div>
      </div>
      <div class="login_box pon">
        <!-- 表单 -->
        <div class="login_box_content">
          <div class="img-container">
            <img class="title-img" v-if="titleImg" :src="titleImg" alt="">
            <p v-else :class="domain === 'sindenden.jp' ? 'set-font' : ''" style="font-size: 21px;font-weight: 500;text-align: center">{{shName}}</p>
            <!--            <img src="../assets/images/login/login_biaoti.png" alt="">-->
<!--            <img src="../assets/images/login/login_biaoti6.png" alt="">-->
          </div>
          <el-form ref="LoginFormRef" :model="loginForm" label-width="0" :rules="LoginFormRules" class="login_form" label-position="top">
            <el-form-item prop="userName" :label="$t('login.login1')">
              <el-input class="login-input" v-model="loginForm.userName" prefix-icon="el-icon-user" :placeholder="$t('login.login3')">
              </el-input>
            </el-form-item>
            <el-form-item prop="password" :label="$t('login.password')">
              <el-input class="login-input" v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" :placeholder="$t('loginR.login16')"
                @keyup.enter.native="login"></el-input>
            </el-form-item>
            <div style="display: flex;flex-direction: column;">
              <div class="flex-space">
                <el-checkbox class="check-flex-center" size="mini" v-model="loginForm.rememberPassword">{{$t('login.login35')}}</el-checkbox>
                <div class="registerText" style="overflow:hidden;justify-content: right">
                  <!-- <span class="action-divider">|</span> -->
                  <el-link type="primary" :underline="false" @click="register">{{$t('loginR.login8')}}</el-link>
                </div>
              </div>
            </div>
            <el-button class="btns" type="primary" @click="login" size="small"><span>{{$t('login.login2')}}</span></el-button>
            <div class="reset">
              <el-link type="primary" :underline="false" @click="logisticsUrl">{{$t('logistics.logistics1')}}</el-link>
              <span @click="resetPassword">{{ $t('loginR.login1') }}</span>
            </div>
          </el-form>
        </div>
        <!-- 物流查询 -->
        <!-- <div class="registerText" style="overflow:hidden">
           <span  style="float:left;height:22px;line-height:20px"><el-link type="primary" :underline="false" @click="logisticsUrl">{{$t('logistics.logistics1')}}</el-link></span>
        </div> -->

<!--        <div class="filing">
          <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2021007835号-2</a>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import { messages, setLang } from '@/i18n'
import Cookies from "js-cookie"
import { encrypt, decrypt } from '@/utils/jsencrypt'
import axios from 'axios'
import {encryption} from '@/utils/other';
export default {
  data () {
    return {
      i18nMessages: messages,
      loginForm: {
        userName: '',
        password: ''
      },
      rememberPassword: false,
      LoginFormRules: {
        userName: [
          { required: true, message: this.$t('login.login3'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('loginR.login16'), trigger: 'blur' },
        ]
      },
      shName: '',
      autoTenantEnable: process.env.VUE_APP_AUTO_TENANT === 'true',
      pageShTitle: 'Trade with Trust, Forever.',
      domain: window.location.host,
      baImg: '',
      titleImg: ''
    }
  },
  metaInfo() {
    return {
      // title: 'ログイン - アリパートナーズ',
      title: this.pageShTitle,
      // titleTemplate: null,
      meta: [
        { name: 'description', content: 'アリパートナーズ倉庫サプライチェーン管理システムにログインし、安全で便利にクロスボーダーECビジネスを管理' },
        { name: 'keywords', content: 'ユーザーログイン,アリパートナーズ,倉庫管理,クロスボーダーEC,サプライチェーン' },
        { property: 'og:title', content: 'ユーザーログイン - アリパートナーズ' },
        { property: 'og:description', content: 'アリパートナーズ倉庫サプライチェーン管理システムにログインし、安全で便利にクロスボーダーECビジネスを管理' }
      ]
    }
  },
  watch: {
    '$store.state.tenantConfig': {
      handler(newVal) {
        if (newVal) {
          this.baImg = newVal.baImg
          this.shName = newVal.name
          this.pageShTitle = newVal.name || 'Trade with Trust, Forever.'
          this.titleImg = newVal.titleImg
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.getCookie()
  },
  mounted() {
  },
  methods: {
    getCookie () {
      const userName = Cookies.get("userName")
      const password = Cookies.get("password")
      const rememberPassword = Cookies.get('rememberPassword')
      this.loginForm = {
        userName: userName === undefined ? this.loginForm.userName : userName,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberPassword: rememberPassword === undefined ? false : Boolean(rememberPassword)

      }
    },
    changeLang (key) {
      this.$i18n.locale = key
      setLang(key)
    },
    resetPassword () {
      this.$router.push({
        name: 'resetPassword'
      })
    },
    resetLoginForm () {
      this.$refs.LoginFormRef.resetFields()
    },
    login () {
      window.sessionStorage.setItem('token', '')
      this.$refs['LoginFormRef'].validate(async (valid) => {
        if (valid) {
          const encPassword = encryption(this.loginForm.password, process.env.VUE_APP_KEY);
          const params = new URLSearchParams()
          params.append('password', encPassword)
          try {

          const { data: res } = await axios.post(`/auth/oauth2/token?username=${this.loginForm.userName}&grant_type=password&scope=server`,  params, {
            baseURL: process.env.VUE_APP_BASE_DOMAIN,
            headers: {
              'CLIENT-TOC': 'Y',
              'Authorization': 'Basic c2hvcDpzaG9w',
              'tenant-id': window.sessionStorage.getItem('tenant-id') || '1', // 需要修改
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          })
          this.$message({
            message: this.$t('login.login4'),
            type: 'success',
            duration: 500
          })
          window.sessionStorage.setItem('token', res.token_type + ' ' + res.access_token)
          this.$store.commit('setIsLogin', true);
          if (this.loginForm.rememberPassword) {
            Cookies.set("userName", this.loginForm.userName, { expires: 30 })
            Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 })
            Cookies.set('rememberPassword', this.loginForm.rememberPassword, { expires: 30 })
          } else {
            Cookies.remove("userName")
            Cookies.remove("password")
            Cookies.remove('rememberPassword')
          }
          await this.$router.push('/')
          }
            catch (error) {
              this.$message({
                message: error.response.data.msg,
                type: 'error',
                duration: 500
              })
            }
        } else {
          return false
        }
      })
    },
    register () {
      window.sessionStorage.clear
      this.$router.push({ name: 'register' })
    },
    // 跳转到物流查询
    logisticsUrl () {
      this.$router.push({ name: 'logisticsInfo' })
    },
  }
}
</script>

<style lang="less" scoped>
.el-form-item {
  height: 40px !important;
}
.el-input__inner {
  font-size: inherit;
}
.login_container {
  height: 100%;
  width: 100%;
  // background: url("../assets/images/login/bg.png") no-repeat;
  background-size: cover;
}
//.login_box{
//  position: relative;
//}
.registerText {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  // position: absolute;
  // bottom: -4%;
  // right: 26%;
}
.login_box_content {
  //padding: 15%;
  //padding-top: 45%;
  width: 360px;
  margin: auto;
  .img-container {
    padding-bottom: 20px;
    img {
      //width: 188px;
      height: 77px;
    }
    .title-img {
      width: 100%;
      height: auto;
    }
  }
}

.img-form {
  overflow: hidden;
  height: 100%;
  position: relative;
  .avatar_box {
    position: relative;
    //float: left;
    width: 100%;
    height: 100%;
    .bg-image {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }
    .message-wrap {
      position: absolute;
      top: 30px;
      right: 30px;
    }
  }
  .login_box {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 37.5%;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
@media screen and (min-width: 1600px) {
  //.avatar_box{
  //  width: 75% !important;
  //}
  //.login_box{
  //  width: 25% !important;
  //}
}

.login_form {
  bottom: 0;
  width: 100%;
  padding: 0px;
  box-sizing: border-box;
  margin-top: 20px;
}
.btns {
  margin-top: 20px;
  width: 263px;
  height: 38px;
  background: linear-gradient(90deg, #269f98, #2e85a1);
  border-radius: 20px;
  color: #ffffff;
}
.btns span {
  font-size: 17px !important;
  letter-spacing: 5px;
}

/deep/ .el-input__prefix,
.el-input__suffix {
  color: #2e85a1 !important;
}

/deep/ .el-input__icon .el-icon-user-solid {
  color: #2e85a1 !important;
}
.footer-container {
  width: 100%;
  position: absolute;
  bottom: 10%;
  text-align: center;
}
.footer {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  letter-spacing: 4px;
  color: #fefeff;
}

.about {
  font-size: 16px;
  font-family: Source Han Sans CN;
  // font-weight: 400;
  color: #fefeff;
  padding-top: 10px;
}
/deep/ .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #e5e9f8 !important;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.pon {
  position: relative;
  .filing {
    position: fixed;
    left: 47%;
    bottom: 20px;
  }
}


.set-font{
  //font-family: "FangSong", "仿宋", "STFangsong", serif;
  //font-weight: 900!important;
  //white-space: nowrap;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 600;
  color: #3a4255;
  text-shadow: 0px 3px 3px rgba(34, 40, 66, 0.43);
}
.el-form-item {
  margin-bottom: 18px !important;
  height: auto !important;
}

.img-form {
  .avatar_box {
    .message-wrap {
      z-index: 10;
    }

    .lang-trigger {
      min-width: 108px;
      height: 38px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.95);
      border: 1px solid #e5e8ef;
      border-radius: 6px;
      box-shadow: 0 8px 24px rgba(29, 55, 93, 0.08);
      color: #2f3a4f;
      font-size: 15px;
      font-weight: 500;
      line-height: 1;
      gap: 8px;
      cursor: pointer;
      user-select: none;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:hover {
        border-color: #c8d5ee;
        box-shadow: 0 10px 28px rgba(29, 55, 93, 0.12);
      }

      .lang-icon {
        color: #2f3a4f;
        flex: none;
      }

      .el-icon-arrow-down {
        color: #6f7f96;
        font-size: 13px;
        font-weight: 600;
        flex: none;
      }
    }
  }
}

.login_form {
  margin-top: 8px;

  /deep/ .el-form-item__label {
    line-height: normal;
    padding: 0 0 5px;
    color: #363c5a;
    font-size: 14px;
  }

  /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    display: none;
  }

  /deep/ .el-checkbox__inner {
    border-color: #363c5a;
    width: 12px;
    height: 12px;

    &:hover {
      border-color: #4b70f1;
      color: #4b70f1;
    }

    &::after {
      left: 3px;
      top: 0;
    }
  }

  /deep/ .el-checkbox {
    .el-checkbox__label {
      padding-left: 5px;
    }

    &:hover {
      .el-checkbox__inner {
        border-color: #4b70f1;
      }

      .el-checkbox__label {
        color: #4b70f1;
      }
    }
  }

  /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #4b70f1;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #4b70f1;
    background-color: #4b70f1;
  }

  /deep/.el-form-item__error {
    font-size: 10px;
    padding-top: 2px;
  }

  .reset {
    display: flex;
    font-size: 14px;
    color: #4b70f1;
    cursor: pointer;
    margin-top: 10px;
    justify-content: space-between;
    /deep/.el-link.el-link--primary {
      color: #4b70f1;
    }
  }

  .flex-space {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .check-flex-center {
      display: flex;
      align-items: center;
    }
  }

  .registerText {
    margin-top: 0;

    .action-divider {
      margin: 0 8px;
      color: #c6cad6;
      font-size: 14px;
    }

    /deep/.el-link.el-link--primary {
      color: #4b70f1;
    }
  }
}

.btns {
  margin-top: 24px;
  width: 100%;
  height: 44px;
  background: #446de3;
  border: none;
  border-radius: 8px;
  color: #ffffff;
}

.btns span {
  font-size: 16px !important;
  letter-spacing: 4px;
}

/deep/ .el-input__prefix,
.el-input__suffix {
  color: #363c5a !important;
}

/deep/ .el-input__icon .el-icon-user {
  color: #363c5a !important;
}

/deep/ .el-input__inner {
  height: 44px;
  line-height: 44px;
  background-color: #f5f6fa !important;
  border: none !important;
  color: #303133;
  padding-left: 42px !important;
  padding-right: 36px !important;
  font-size: 14px;
}

/deep/ .el-input__inner::placeholder {
  color: #b6b9c4;
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 42px !important;
}

/deep/ .el-input__prefix {
  left: 14px;
}

/deep/ .el-input__prefix .el-input__icon {
  line-height: 44px;
  font-size: 18px;
}

.login-input {
  /deep/ .el-input__inner {
    border: 1px solid #EAEBEF !important;
    border-radius: 8px !important;
  }
}
</style>
